import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    cursor: "grab",
  },

  dragging: {
    borderRadius: 5,
    border: "none",
    zIndex: 2,
    boxShadow: "0px 0px 30px rgba(149, 169, 177, 0.3)",
    background: "white",
    cursor: "grabbing",
    position: "relative",
  },
}));

const SortableItem = (props) => {
  const { renderChild, id } = props;
  const classes = useStyles();
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  /**
   * CSS.Translate allows for moving items of variable height
   */
  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    width: "100%",
    zIndex: "1000 !important",
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={clsx(classes.root, { [classes.dragging]: isDragging })}
      {...attributes}
    >
      {renderChild({ isDragging, listeners, ...props })}
    </div>
  );
};

export default SortableItem;
